// extracted by mini-css-extract-plugin
module.exports = {"title":"r-goV9Q8nQOg-EYC76cdR","border":"_2BycLM3GaXFXEoogqGhB0J"};